export type ZuuDisplayMode = "original" | "zuu";
export type ZuuCompletionTone = "empty" | "active" | "complete";

export function getZuuModeSwitchLabels(mode: ZuuDisplayMode) {
  return mode === "zuu"
    ? {
        collapsedLabel: "原版",
        expandedLabel: "返回原版",
        ariaLabel: "返回原版客戶詳情頁",
      }
    : {
        collapsedLabel: "ZUU",
        expandedLabel: "切換 ZUU 版",
        ariaLabel: "切換到 ZUU 專屬詳情頁",
      };
}

export function clampZuuCompletion(value?: number) {
  if (typeof value !== "number" || Number.isNaN(value)) return 0;
  return Math.min(100, Math.max(0, Math.round(value)));
}

export function getZuuCompletionTone(value?: number): ZuuCompletionTone {
  const completion = clampZuuCompletion(value);
  if (completion <= 0) return "empty";
  if (completion >= 100) return "complete";
  return "active";
}
